import { s as stripe } from "../../../../../../chunks/stripe.js";
const load = async ({ url }) => {
  const { searchParams } = url;
  const sessionId = searchParams.get("sessionId");
  const price = searchParams.get("price");
  const customerId = searchParams.get("customer-id");
  const session = await stripe.checkout.sessions.retrieve(sessionId);
  const success = session.payment_status === "paid";
  return {
    checkout: {
      success,
      price,
      customerId
    }
  };
};
export {
  load
};
